/**
 * Detalle libre (JSONB) en una línea legible: `clave: valor · clave: valor`.
 * El JSON entero queda en el `title` para quien necesite verlo todo.
 */
export function JsonDetail({ value }: { value: unknown }): JSX.Element {
  if (value === null || value === undefined) return <span className="subtle">—</span>;
  let text: string;
  if (typeof value === 'object' && !Array.isArray(value)) {
    const entries = Object.entries(value as Record<string, unknown>);
    if (entries.length === 0) return <span className="subtle">—</span>;
    text = entries.map(([k, v]) => `${k}: ${typeof v === 'string' ? v : JSON.stringify(v)}`).join(' · ');
  } else {
    text = typeof value === 'string' ? value : JSON.stringify(value);
  }
  return (
    <span className="json-detail" title={JSON.stringify(value, null, 2)}>
      {text}
    </span>
  );
}
